// Centralized order status helpers: colors and i18n keys

export const ORDER_STATUSES = [
  "CREATED",
  "WAITING_SCHEDULED",
  "WAITING_RESTAURANT",
  "ACCEPTED",
  "REJECTED",
  "PREPARING",
  "READY_FOR_PICKUP",
  "PICKED_UP",
  "ARRIVED_AT_CUSTOMER",
  "CANCELLED",
  // legacy statuses still seen in some flows
  "PENDING",
  "CONFIRMED",
] as const;

export type OrderStatus = typeof ORDER_STATUSES[number];

// Ant Design preset colors
const STATUS_COLOR_MAP: Record<string, string> = {
  CREATED: "gold",
  WAITING_SCHEDULED: "gold",
  WAITING_RESTAURANT: "geekblue",
  ACCEPTED: "green",
  REJECTED: "red",
  PREPARING: "orange",
  READY_FOR_PICKUP: "blue",
  PICKED_UP: "cyan",
  ARRIVED_AT_CUSTOMER: "purple",
  CANCELLED: "volcano",
  // legacy
  PENDING: "gold",
  CONFIRMED: "geekblue",
};

export function getOrderStatusColor(status: string): string {
  return STATUS_COLOR_MAP[status?.toUpperCase?.()] || "default";
}

export function getOrderStatusI18nKey(status: string): string {
  const normalized = status?.toLowerCase?.() || "";
  // ensure legacy to existing keys
  // ready-made keys are kebab/underscore cased in locale files
  return `status.${normalized}`;
}



